export default "/048cb1f2b29308e18768c65cfd51e426596a830c/569373b84d4fa61cda98164451d2ed57.svg";